export enum LanguageOption {
	Fr = 'fr',
	En = 'en',
	Es = 'es',
}
